export const INTRO_CONSTANTS = {
  title: "Defense Against Ransomware, DDoS & Unauthorized Access ",
  text: "OneMind Services provides enterprise-grade cybersecurity solutions designed to detect, prevent, and respond to cyber threats before they impact your business. Our multi-layered security strategy ensures continuous monitoring, rapid incident response, and compliance enforcement to protect your data, cloud environments, and IT infrastructure.",
};
